import type { WithArdoqPersistent } from '@ardoq/api-types';

export type ContextSwitchSetting = Pick<WithArdoqPersistent, 'ardoqPersistent'>;

export const getContextSwitchEnabled = (
  presentation: ContextSwitchSetting | null
): boolean => presentation?.ardoqPersistent?.contextSwitch?.enabled ?? false;
